import { Input, OnInit } from '@angular/core';
import { Component } from '@angular/core';

import { AppService } from '../../services/app.service';
import { VaccinationDocumentService } from '../../services/vaccination-document.service';
import { IVaccinationDocument } from '../../models/VaccinationDocument';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VaccinationDocumentApprovalComponent } from './approval.component';

@Component({
    selector: 'app-vaccination-document-view',
    templateUrl: './view.component.html'
})
export class VaccinationDocumentViewComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: VaccinationDocumentService,
        private modal: NgbModal
    ) { }

    @Input() document: IVaccinationDocument;

    canReview: boolean;
    canPickStudent: boolean;

    ngOnInit() {
        this.canPickStudent = this.app.currentUser.hasRight('VACCINATION_DOCUMENT.ADMIN');
        this.canReview = this.document.Status == 'Submitted' && this.app.currentUser.hasRight('VACCINATION_DOCUMENT.APPROVE');
    }

    download() {
        this.app.addLoading(this.service.download(this.document.Id)).subscribe();
    }

    review() {
        const ref = this.modal.open(VaccinationDocumentApprovalComponent);
        ref.componentInstance.document = this.document;
        ref.result.then(() => {
            this.app.navigate(['/vaccination-documents']);
        }, () => { });
    }
}
